import { Tag } from 'antd';
import React from 'react';
import { DynamicObjectType } from 'types/commons';
import { useRestContext } from '../RestInputContext';

export interface HighlightLabelProps {
  src?: string;
  highlightName?: string;
  formatHightLight?: (
    src: string,
    values?: DynamicObjectType,
  ) => {
    color: string;
    label: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
  } | null;
}

const defaultHight = (src, highlightValue) =>
  src === highlightValue
    ? {
        color: 'var(--primary)',
        label: 'Main',
        className: '',
        style: {},
      }
    : null;

export default function HighlightLabel({
  src,
  formatHightLight,
  highlightName,
}: HighlightLabelProps) {
  const { form } = useRestContext();
  const highlight = formatHightLight
    ? formatHightLight?.(src, form.getFieldsValue())
    : defaultHight(src, form.getFieldValue(highlightName));
  return highlight ? (
    <Tag
      style={highlight?.style}
      className={highlight?.className}
      color={highlight?.color}
    >
      {highlight.label}
    </Tag>
  ) : null;
}
